/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './appointment-status.reducer';

export const AppointmentStatusDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const appointmentStatusEntity = useAppSelector(state => state.appointmentStatus.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="appointmentStatusDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.appointmentStatus.detail.title">AppointmentStatus</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.appointmentStatus.id">Id</Translate>
            </span>
          </dt>
          <dd>{appointmentStatusEntity.id}</dd>
          <dt>
            <span id="description">
              <Translate contentKey="tinyMedicRestApp.appointmentStatus.description">Description</Translate>
            </span>
          </dt>
          <dd>{appointmentStatusEntity.description}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.appointmentStatus.active">Active</Translate>
            </span>
          </dt>
          <dd>{appointmentStatusEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.appointmentStatus.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{appointmentStatusEntity.timestampentry}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.appointmentStatus.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{appointmentStatusEntity.microSec}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.appointmentStatus.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{appointmentStatusEntity.lastupdated}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.appointmentStatus.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{appointmentStatusEntity.cursor}</dd>
          <dt>
            <span id="code">
              <Translate contentKey="tinyMedicRestApp.appointmentStatus.code">Code</Translate>
            </span>
          </dt>
          <dd>{appointmentStatusEntity.code}</dd>
        </dl>
        <Button tag={Link} to="/appointment-status" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/appointment-status/${appointmentStatusEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default AppointmentStatusDetail;
